

export const baseUrlConfig = {
  development: 'https://api.staging.voltmoney.in',
  production: 'https://api.voltmoney.in',
  testing: 'https://api.testing.voltmoney.in',
};

export const amplitudeConfig = {
  development: '0db77c455f0b7518a30b95598a6e5e5b',
  testing: '0db77c455f0b7518a30b95598a6e5e5b',
  qa: '0db77c455f0b7518a30b95598a6e5e5b',
  production: 'f15bbbe2415bf57272c15694aa4358ec',
}

const SignDeskSDKUrl = {
  development: 'https://signdesk.in/api/eSignWidgetUat.js',
  production: 'https://signdesk.in/api/eSignWidgetLive.js',
};

const environmentBaseKey = 'production';
console.log('ENVIROMENT', process.env.NODE_ENV);
export const baseUrl = baseUrlConfig['production'];
export const signDeskSDKUrl = SignDeskSDKUrl[environmentBaseKey];
export const digioEnvironment = {
  development: 'sandbox',
  production: 'production'
}
export const DIGIO_ENVIRONMENT = digioEnvironment[environmentBaseKey];


export const isProduction = baseUrl === baseUrlConfig['production'];
export const baseAmplitudeConfig = amplitudeConfig[environmentBaseKey];

export const VoltWebSiteBaseLink = isProduction ? "https://voltmoney.in/" : "https://staging.voltmoney.in/"

export const endpoints = {
  refreshToken: '/api/client/refresh/token',
  getAuthToken: '/api/client/las/customer/getAuthToken',
  generateLoginOTP: '/api/client/auth/requestOtp/v2',
  verifyLoginOTP: '/api/client/auth/verifyOtp/',
  requestEmailOTP: '/api/client/auth/requestOtp/email',
  verifyEmailOTP: '/api/client/auth/verifyOtp/email',
  emailInit: '/app/borrower/application/email/verification/otp/init',
  emailVerify: '/app/borrower/application/email/verification/otp/verify',
  getEmailVerificationDetails: '/app/borrower/application/email/verification/',
  googleEmailUpdateAttribute: '/app/borrower/application/email/verification/googleEmail/updateAttribute',
  userInfo: '/app/borrower/user',
  userProfile: '/app/borrower/userProfile/',
  pledgeData: '/app/borrower/application/asset/pledge/details/',
  accountAttributes: '/app/borrower/accountAttributes/',
  verifyPan: '/app/borrower/application/kyc/pan/panVerify',
  resetPan: '/app/borrower/application/kyc/pan/panReset/',
  showEnableLimit: '/app/borrower/application/enable/edit/limit/',
  editLimitRoute: '/app/borrower/application/edit/limit/',
  platformDetailsApi: '/app/pf/details/',
  getLenderInfo: '/app/borrower/application/creditApplication/lender/info/',
  logout: '/api/client/logout',
  bav: `/app/borrower/application/bav/`,
  bavVerify: `/app/borrower/application/bav/v2/verify`,
  allBanks: `/util/bankInfo/banks`,
  bankInfoSearch: `/util/bankInfo/search/`,
  getStepper: `/app/borrower/application/stepper`,
  nameMismatchResponse: `/app/borrower/application/persist/mismatch/issue/`,
  supportingDocumentInfoForLender: `/app/borrower/application/creditApplication/lender/supportingDocument/info/`,
  borrowerApplication: `/app/borrower/application/`,
  presignedUrlForAdditionalDocumentToUpload: `/app/borrower/application/getPreSignedUrl/additionalDocument/upload/`,
  submitSupportDocuments: `/app/borrower/application/creditApplication/mismatch/appeal`,
  dspMandateInitiateRequest: `/app/borrower/application/mandate/digio/init/v2`,
  digioMandateCheckRequestStatusOnCallBack: `/app/borrower/application/mandate/digio/status/deep/v2/`,
  pledgeInit: `/app/borrower/application/asset/pledge/v2/init/otp`,
  assetPledgeVerify: `/app/borrower/application/asset/pledge/verify/otp`,
  mandateLink: `/app/borrower/application/agreement/loan/contract/link/`,
  mfCentralEvaluateFunds: `/app/borrower/application/fetch/mfc/poller/`,
  pledgeLimit: '/app/borrower/application/pledge/limit/',
  kycDSPInit: `/app/borrower/application/kyc/documents/digio/init/`,
  kycTATAInit: `/app/borrower/application/kyc/documents/digilocker/init/`,
  kycDSPStatus: `/app/borrower/application/kyc/documents/digio/status/deep/`,
  kycTATAInitURL: `/app/borrower/application/kyc/documents/digilockerUrl/`,
  kycTATAStatus: `/app/borrower/application/kyc/documents/digilocker/status/`,
  processingCharges: `/app/borrower/application/pledge/processingCharges`,
  kycPhotoUploadPreSignedURL: `/app/borrower/application/kyc/photo/init`,
  kycPhotoVerify: `/app/borrower/application/kyc/photo/verify/v2`,
  kycSummaryInit: `/app/borrower/application/kyc/summary/init/`,
  kycSummaryEdit: `/app/borrower/application/creditApplication/should/show/kycEdit/`,
  updateUserKYC: `/app/borrower/application/creditApplication/add/kyc/`,
  kycSummaryVerify: `/app/borrower/application/kyc/summary/verify/`,
  mandateStatus: `/app/borrower/application/agreement/loan/contract/status/`,
  creditPollingAPI: `/app/borrower/application/check/shallow/creditApproval/`,
  mandateTataLink: `/app/borrower/application/tata/mandate/link/`,
  tatamMandateStatus: `/app/borrower/application/tata/mandate/status/v2/`,
  initKfsTata: `/app/borrower/application/signdesk/esign/kfs-file/init/`,
  pollKfsTata: `/app/borrower/application/signdesk/esign/kfs-file/poll/`,
  esignInit: `/app/borrower/application/signdesk/esign/init/`,
  validateEsign: `/app/borrower/application/signdesk/esign/validate/`,
  checkEsignStatusTata: `/app/borrower/application/signdesk/esign/status/deep/`,
  additionalDetails: `/app/borrower/application/additionalDetails/`,
  showEditLimit: `/app/borrower/application/enable/edit/limit/application/`,
  editLimit: `/app/borrower/application/edit/limit/`,
  checkEnabledRTA: `/app/borrower/application/fetch/enabledRTAFlow/`,
  stampDutyCharges: `/util/statesForStampDuty/`,
  overrideState: `/app/borrower/application/override`,
  loanOfferDetails: `/app/borrower/application/loan/offer/details/`,
  getFetchSDK: `/app/borrower/application/dsp/sdk/init`,
  getDefaultRTA: `/app/borrower/application/fetch/v2/default/rta/`,
  fetchSDKCallback: `/app/borrower/application/fetch/dsp/sdk/callback/`,
  fetchInit: `/app/borrower/application/fetch/init/otp/v3`,
  fetchVerify: `/app/borrower/application/fetch/authCAS/v2`,
  evaluate: '/app/borrower/application/credit/profile/evaluate',
  pledgeSave: '/app/borrower/application/pledge/save',
  activateAsset: `/app/borrower/application/asset/pledge/activate/`,
  checkCustomerEligibility: `/app/borrower/application/checkCustomerEligibility/`,
  checkCibilStatus: `/app/borrower/application/cibilCheck/`,
  fetchInitV2: `/app/borrower/application/pledge/v2/init`,
  authCAS: `/app/borrower/application/pledge/authCAS`,
  getCredentialsForAssetFetch: `/app/borrower/application/asset/fetch/credentials`,




  registerOrUpdateFCMToken: '/app/device/details/registerOrUpdateToken',

  // LMS
  creditInfo: '/app/borrower/lms/credit/',
  checkWithdraw: '/app/borrower/lms/disbursal/requestDetails',
  transactionHistory: '/app/borrower/lms/transactions/history/',
  interestDetails: '/app/borrower/lms/interestCollection/details/',
  pendingRequests: '/app/borrower/lms/getPendingCreditRequestsByCreditId/',
  transactionEmail: '/app/borrower/lms/transactions/email/',
  pdfHoldingStatement: '/app/borrower/lms/holdingStatement/email/',
  requestWithdrwalOtp: '/app/borrower/lms/disbursal/v2/',
  verifyWithdrawlOtp: '/app/borrower/lms/disbursal/verifyOTP',
  bankTransferDetails: '/app/borrower/lms/repaymentBankAccountsDetails/',
  disbursalDetails: '/app/borrower/lms/disbursal/credit/',
  forclosureDetails: '/app/borrower/lms/credit/foreclosure/',
  checkForClosureStatus: '/app/borrower/lms/credit/foreclosure/requests/inprogress/',
  shortFallDetails: '/app/borrower/shortfall/data/',
  tataPayment: '/app/borrower/application/tata/merger/enabled/',
  paymentInit: '/app/borrower/lms/collection/new',
  paymentPolling: '/app/borrower/lms/collection/',
  pleadgeList: '/app/borrower/lms/collateralDetails/',
  enhanceLimit: '/app/borrower/creditModification/',
  getForeclosureDetails: '/app/borrower/lms/foreclosure/',
  requestAccVerifyOtp: '/user/borrower/account/accountVerify/request/otp/init/',
  accVerifyOtp: '/user/borrower/account/accountVerify/request/otp/verify',
  verifyOtpNewuserDetails: '/user/borrower/account/updateAccount/request/otp/verify',
  loanDetails: '/app/borrower/lms/credit/loanDetails/',
  updateAccOtp: '/user/borrower/account/updateAccount/request/otp/init',
  createRevocation: '/app/borrower/lms/createRevocation/otp/',
  verifyRevocation: '/app/borrower/lms/createRevocation/verifyOTP',
  pledgeHistory: '/app/borrower/lms/getAllCreditRequestsByCreditId/',
  renewalBreakUp: '/app/borrower/application/renewal/chargesDetails/',
  creditModification: '/app/borrower/creditModification/',
  renewalSummary: '/app/borrower/application/offer/selection/init/',
  failedRequests: '/app/borrower/lms/getFailedCreditRequestsByCreditId/',
  renewAppliction: '/app/borrower/application/',
  getOfferSelectionInit: '/app/borrower/application/offer/selection/verify/',
  dspPaymentCallback: '/app/borrower/lms/collection/deep/',
  paymentCallback: '/app/borrower/lms/collection/',
  pledgeDetails: '/app/borrower/application/asset/pledge/details/',
  manageLimitConfig: '/app/borrower/lms/credit/lender/manageLimitConfig/',
  switchCredit: '/app/borrower/switchCredit',
  getRevocationList: '/app/borrower/lms/getRevocationByCreditId/status/',
  foreclosureValidationAndDetails: `/app/borrower/lms/foreclosure/validationAndDetails/`,
  initForeclosureV1: `/app/borrower/lms/foreclosure/otp/init/`,
  verifyForeclosureV2: `/app/borrower/lms/foreclosure/otp/verify/`,
  initiateForeclosure: `/app/borrower/lms/foreclosure/otp/init/v2`,
  verifyForeclosure: `/app/borrower/lms/foreclosure/otp/verify/v2`,
  cancelForeclosure: `/app/borrower/lms/cancel/foreclosure/request/`,
  getPendingDetailsRequest: '/user/borrower/account/updateAccount/request/borrowerAccount/',
  getForeclosureCompleted: `/app/borrower/lms/foreclosure/details/foreclosure/request/account/latest/`,
  reopenAccount: '/app/borrower/lms/reopen/closed/account/',
  accountOpenInfo: '/app/borrower/lms/disbursal/minAmount/details',
  checkFrozenStatus: `/app/borrower/lms/creditAssetMapping/revocation/validationAndDetails/`,
  isPendingDisbursal: `/app/borrower/lms/credit/disbursal/pending/`,
  enhanceLimitApplicationDetailsV2: `/app/borrower/application/creditApplication/filter/current/applicationDetails/credit/`,
  bookTransferV2: '/app/borrower/bookTransfer/',
  generateMfdShareLink: `/app/borrower/application/mfd/link/generate/`,
  mfdSharelinkCustomerDetails: `/api/client/auth/mfd/link/`,
  mfdShareLinkInit: `/api/client/auth/mfd/link/requestOtp/`,
  mfdShareLinkVerify: `/api/client/auth/mfd/link/verifyOtp`,
  repaymentSchedule: '/app/borrower/lms/repaymentSchedule/credit/',
  kycDSP: `/app/borrower/application/kyc/documents/dsp/init/`,
  digioMode: `/app/borrower/application/kyc/documents/digilocker/mode/`,
  dspDeepStatus: `/app/borrower/application/kyc/documents/dsp/status/deep/`,
  otpFeedback: `/app/borrower/customerFeedback/otpFeedback`,
  bankAndMandateDetails: `/app/borrower/bankAndMandateDetails/`,
  creditLoanServicingApplication: `/app/borrower/creditLoanServicingApplication/`,
  getBankAccountDetailsForLoanServicingApplication: `/app/borrower/application/getBankAccountDetailsForLoanServicingApplication/`,
  removeFundsAndPledgeMfc: `/app/borrower/application/asset/pledge/handleAction`,
  referralDashboard: `/app/borrower/referral`,
  referralBanner: `/app/borrower/referral/`,
};



